import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  pieAnimationMorph,
  backgroundColor,
  color,
  datasetXY,
  datasetPivot,
  initDonut,
  pieAnimation,
  pieGeometry,
  centerText,
  initPivot,
  discreteLegend,
  pivotAdapter,
  pivotColumnDimensions,
  pivotGridStyle,
  pivotIndicators,
  pivotIndicatorsAsRow,
  pivotDiscreteLegend,
  pivotRowDimensions,
  tooltip,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  pivotColorLegend,
  pieStyle,
  pieHover,
  colorPieStyleFill,
  labelPie,
  pivotHideIndicatorName,
  pivotTitle,
  addRegionPadding,
  brush,
  dimensionLinkage,
  fontFamilyTheme,
} from '../pipes'

const donut: VChartSpecPipeline = [
  fontFamilyTheme,
  initDonut,
  pieAnimation,
  pieGeometry,
  centerText,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  pieAnimationMorph,
  progressive,
  brush,
  labelPie,
  colorPieStyleFill(pieStyle),
  pieHover,
  colorAdapter(discreteLegend, colorLegend),
  tooltip({ titleEncoding: 'color' }),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
]

const pivotDonut: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  pivotHideIndicatorName,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initDonut,
    pieAnimation,
    pieGeometry,
    centerText,
    addRegionPadding,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetXY,
    pieAnimationMorph,
    progressive,
    brush,
    labelPie,
    colorPieStyleFill(pieStyle),
    pieHover,
    tooltip({ titleEncoding: 'color' }),
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationArea,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const donutSpecPipeline = [pivotAdapter(donut, pivotDonut)]
